import Error404 from "./pages/Error404";
import Inicio from "./pages/Inicio";
import Programa from "./pages/Programa";
import Actividades from "./pages/Actividades";
import JefesCarrera from "./pages/JefesCarrera";
import ProgramaCarrera from "./pages/ProgramaCarrera";
import ActividadesModulo from "./pages/ActividadesModulo";

const MainMenu = [
	{name: 'inicio', path: '/', component: Inicio, meta: {title: 'Inicio'}},
	{name: 'programa', path: '/programa', component: Programa, meta: {title: 'Programa'}},
	{name: 'actividades', path: '/actividades', component: Actividades, meta: {title: 'Actividades'}},
	{name: 'jefes-carrera', path: '/jefes-carrera', component: JefesCarrera, meta: {title: 'Jefes/as de Carrera'}},
];

const routes = [
	...MainMenu,
	{name: 'programa-carrera', path: '/programa/:carrera', component: ProgramaCarrera, meta: {title: 'Programa :carrera'}},
	{name: 'actividades-modulo', path: '/actividades/:modulo', component: ActividadesModulo, meta: {title: 'Actividades :modulo'}},
	{name: 'error-not-found', path: '/:catchAll(.*)', component: Error404, meta: {title: 'Error 404'}}
];

export {routes as default, MainMenu};